// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organize-container {
  max-width: 800px;
  margin: auto;
  padding: 20px;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 5px;
  margin-bottom: 15px;
}

label {
  display: block;
  margin-top: 10px;
}

input[type="text"],
input[type="datetime-local"],
input[type="number"],
select {
  width: 100%;
  padding: 8px;
  margin-top: 4px;
}

.message-box {
  margin-top: 20px;
  background: #e6f7e6;
  padding: 10px;
  border: 1px solid #4CAF50;
  color: #2e7d32;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrganizeExam.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".organize-container {\n  max-width: 800px;\n  margin: auto;\n  padding: 20px;\n}\n\n.checkbox-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 5px;\n  margin-bottom: 15px;\n}\n\nlabel {\n  display: block;\n  margin-top: 10px;\n}\n\ninput[type=\"text\"],\ninput[type=\"datetime-local\"],\ninput[type=\"number\"],\nselect {\n  width: 100%;\n  padding: 8px;\n  margin-top: 4px;\n}\n\n.message-box {\n  margin-top: 20px;\n  background: #e6f7e6;\n  padding: 10px;\n  border: 1px solid #4CAF50;\n  color: #2e7d32;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
